import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  contentHeader: {
    background: "#fff",
    padding: "0 20px",
    boxSizing: "border-box",
    minHeight: "40px",
    alignItems: "center",
    justifyContent: "space-between",
    lineHeight: "1.5",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "10px 15px",
    },
  },
  title: {
    fontSize: "18px",
    margin: 0,
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
      marginBottom: theme.spacing(1),
    },
  },
  breadcrumb: {
    display: "flex",
    listStyle: "none",
    padding: 0,
    margin: 0,
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  breadcrumbItem: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
    "&:last-child": {
      marginRight: 0,
    },
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
    "&.active a": {
      fontWeight: "bold",
      color: theme.palette.secondary.main,
    },
    "&::after": {
      content: "'/'",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    "&:last-child::after": {
      content: '""',
    },
  },
  breadcrumbWrapper: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
    [theme.breakpoints.up("md")]: {
      flexWrap: "nowrap",
    },
  },
}));

const Breadcrumbs = ({ title, crumbs }) => {
  const classes = useStyles();
  return (
    <section className={classes.contentHeader}>
      <h3 className={classes.title}>{title}</h3>
      <div className={classes.breadcrumbWrapper}>
        <ol className={classes.breadcrumb}>
          {crumbs.map((crumb, index) => (
            <li key={index} className={classes.breadcrumbItem}>
              <Link to={crumb.link} className={crumb.active ? "active" : ""}>
                {crumb.name}
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Breadcrumbs;
